module.exports = __webpack_public_path__ + "static/media/serv-9.c6701002.jpg";